import { useCurrentPos } from "../hooks/use-current-pos";
import { cn } from "@repo/ui/lib/utils";

interface LogoProps {
  className?: string;
}

export function Logo({ className }: LogoProps) {
  const pos = useCurrentPos();
  if (pos.club?.logo) {
    return (
      <img
        src={pos.club.logo}
        alt={pos.club.name}
        className={cn("max-w-24 max-h-12", className ?? "")}
      />
    );
  }
  return (
    <div>
      <span className="text-sm font-medium text-neutral-600">
        {pos.club.name.charAt(0).toUpperCase()}
      </span>
    </div>
  );
}
